import React from 'react';
import {logout} from "../../services/PostService";
import {Nav} from "react-bootstrap";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";

export default class NavUserComponent extends React.Component
{
	state = {
		showDoneModal : false
	}
    static propTypes = {
        customerName: PropTypes.string.isRequired,
        language: PropTypes.string.isRequired,
        userName: PropTypes.string
    };


	closeDoneModal = () =>{
		this.setState({showDoneModal : false})
	}
	handleLogout =() =>{
		this.openDoneModal();
	}

	openDoneModal = () =>{
		this.setState({showDoneModal : true})
	}

    logout = () => {
        logout(sessionStorage.getItem('userId-' + this.props.customerName), sessionStorage.getItem('apiKey-' + this.props.customerName)).then( () => {
            sessionStorage.clear();
            window.location = '/'+this.props.language+'/gate/'+this.props.customerName+'/positions';
        });

    };

    render(){
        let userName = this.props.userName || sessionStorage.getItem('userName-' + this.props.customerName);
        if (!userName) {
            return null;
        }

        return (
            <>
				<Modal id="register-done" show={this.state.showDoneModal} onHide={this.closeDoneModal} animation={false}
					   dialogClassName={'smallDialog'}>
					<Modal.Body>
						<i className="fa fa-check-circle fa-3x"/>
						<h5>{window.Translator.getSlug('Done', this.props.language)}</h5>
						<p>{window.Translator.getSlug('ThankYouGoodLuck', this.props.language)}</p>
						<button onClick={this.logout}
								className={'btn btn-default'}>
							{window.Translator.getSlug('Close', this.props.language)}
						</button>
					</Modal.Body>
				</Modal>
                <Nav.Item>
                    <Nav.Link href={'/'+this.props.language+'/gate/'+this.props.customerName+'/profile'}>
                        <i className="fa fa-fw fa-user"/> {userName}
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link onClick={this.handleLogout}>
                        <i className="fa fa-fw fa-sign-out-alt"/> {window.Translator.getSlug('Finish', this.props.language)}
                    </Nav.Link>
                </Nav.Item>
            </>

        );
    }
}
